import { render, staticRenderFns } from "./OhsMain.vue?vue&type=template&id=d3002c26&scoped=true&"
import script from "./OhsMain.vue?vue&type=script&lang=js&"
export * from "./OhsMain.vue?vue&type=script&lang=js&"
import style0 from "./OhsMain.vue?vue&type=style&index=0&id=d3002c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3002c26",
  null
  
)

export default component.exports